<template>
  <el-popover
    ref="popover"
    :popper-class="computedClass"
    :disabled="disabled"
    :placement="placement"
    :width="width"
    :transition="transition"
    :visible-arrow="visibleArrow"
    :trigger="trigger"
    :popper-options="{
      boundariesElement: 'viewport',
      gpuAcceleration: false,
      modifiers: [
        'shift',
        'offset',
        setCustomStyle,
        'preventOverflow',
        'keepTogether',
        'arrow',
        'flip',
        'applyStyle'
      ]
    }"
    v-bind="$attrs"
    v-model="visible"
    @show="$emit('show')"
    @hide="$emit('hide')"
  >
    <slot></slot>
    <template slot="reference">
      <slot name="reference"></slot>
    </template>
  </el-popover>
</template>

<script>
export default {
  name: "base-dropdown",
  data() {
    return {
      visible: false
    }
  },
  props: {
    placement: {
      type: String,
      default: "bottom"
    },
    width: {
      type: String,
      default: "160"
    },
    transition: {
      type: String,
      default: "el-zoom-in-top"
    },
    visibleArrow: Boolean,
    trigger: {
      type: String,
      default: "click"
    },
    marginTop: {
      type: [Number, String],
      default: 10
    },
    disabled: Boolean,
    popoverClass: String
  },
  computed: {
    computedClass() {
      if (!this.popoverClass) return "base-dropdown"
      return `base-dropdown ${this.popoverClass}`
    }
  },
  methods: {
    setCustomStyle(data) {
      data.styles.marginTop = `${this.marginTop}px`
      return data
    },
    open() {
      this.visible = true
      this.$refs.popover.showPopper = true
    },
    close() {
      this.visible = false
      this.$refs.popover.showPopper = false
    }
  }
}
</script>

<style lang="scss">
.base-dropdown.el-popover {
  padding: 0;
  min-width: unset;
  text-align: unset;
}
</style>
